import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { hasLink } from '@ngxp/rest';
import { doNothingAction } from '@schir-int-client/ngrx-helpers';
import { VerfahrenLinkRel, verfahrenSingleSelector } from '@schir-int-client/verfahren-shared';
import { of } from 'rxjs';
import { map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { AppState } from '../../../../apps/int-client/src/app/shared/store/app-state.model';
import {
	createAlternativeTextEntryAction,
	createAlternativeTextEntrySuccessAction,
	deleteAlternativeTextEntryAction,
	deleteAlternativeTextEntrySuccessAction,
	loadAlternativeTexteAction,
	loadAlternativeTexteSuccessAction,
	updateAlternativeTextEntryAction,
	updateAlternativeTextEntrySuccessAction,
} from './alternative-text.actions';
import { AlternativeTextService } from './alternative-text.service';

@Injectable()
export class AlternativeTextEffects {
	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private service: AlternativeTextService
	) {}

	loadAlternativeTextEntries = createEffect(() =>
		this.actions.pipe(
			ofType(loadAlternativeTexteAction),
			withLatestFrom(this.store.select(verfahrenSingleSelector)),
			switchMap(([, verfahren]) => {
				if (!hasLink(verfahren, VerfahrenLinkRel.ALTERNATIVE_TEXTE)) {
					return of(doNothingAction());
				}
				return this.service
					.getAlternativeTexte(verfahren)
					.pipe(map(alternativeTexte => loadAlternativeTexteSuccessAction({ alternativeTexte })));
			})
		)
	);

	createAlternativeTextEntry = createEffect(() =>
		this.actions.pipe(
			ofType(createAlternativeTextEntryAction),
			mergeMap(({ flaggenrechtResource, alternativeText }) => {
				return this.service
					.createAlternativeText(flaggenrechtResource, alternativeText)
					.pipe(
						map(alternativeTextResource =>
							createAlternativeTextEntrySuccessAction({ alternativeTextResource })
						)
					);
			})
		)
	);

	updateAlternativeTextEntry = createEffect(() =>
		this.actions.pipe(
			ofType(updateAlternativeTextEntryAction),
			mergeMap(({ alternativeTextResource, alternativeText }) => {
				return this.service
					.updateAlternativeText(alternativeTextResource, alternativeText)
					.pipe(
						map(alternativeTextResource =>
							updateAlternativeTextEntrySuccessAction({ alternativeTextResource })
						)
					);
			})
		)
	);

	deleteAlternativeTextEntry = createEffect(() =>
		this.actions.pipe(
			ofType(deleteAlternativeTextEntryAction),
			mergeMap(({ alternativeTextResource }) => {
				return this.service
					.deleteAlternativeText(alternativeTextResource)
					.pipe(map(() => deleteAlternativeTextEntrySuccessAction({ alternativeTextResource })));
			})
		)
	);
}
